import { Collapse, Divider, Spin } from "antd";
import {
	SubmitButtonOverlay,
	ActionContainer,
	ActionItemsContainer,
} from "../../components/styled/common";
import { MobileAppVersionItems } from "./constants";
import CollapseExpandIcon from "../../components/CollapseExpandIcon";
import MainButtonComponent from "../../components/MainButtonComponent";
import { useMobileAppVersionContext } from "../../context/MobileAppVersionContext/MobileAppVersionContext";
import { useEffect } from "react";
import { useParams } from "react-router-dom";

const EditMobileAppVersion = () => {
	const { id } = useParams<{ id: string }>();
	const { updateMobileAppVersion, operationStatus, getMobileAppVersionDetails } = useMobileAppVersionContext();

	useEffect(() => {
		if (id) {
			getMobileAppVersionDetails(id);
		}
	}, [id]);

	return (
		<ActionContainer>
			<Spin spinning={operationStatus.type === "loading" && operationStatus.operation === "fetch"}>
				<ActionItemsContainer>
					<h3>Mobil Uygulama Sürümünü Güncelle</h3>
					<Divider />
					<Collapse
						items={MobileAppVersionItems}
						expandIconPosition="end"
						bordered={false}
						ghost
						expandIcon={CollapseExpandIcon}
						defaultActiveKey={["1", "2"]}
					/>
					<SubmitButtonOverlay>
						<MainButtonComponent onClick={updateMobileAppVersion} type="default" loading={operationStatus.type === "loading" && operationStatus.operation === "update"}>
							Güncelle
						</MainButtonComponent>
					</SubmitButtonOverlay>
				</ActionItemsContainer>
			</Spin>
		</ActionContainer>
	);
};

export default EditMobileAppVersion;
